import React from "react";
interface IconProps {
    fill: string;
    class?: string;
    className?: string;
    height: number;
}


export const CameraIcon = (props: IconProps) => (
    <svg fill={props.fill} className={props.class} viewBox="0 0 242.179 242.179" width={props.height} height={props.height} >
        <g>
            <path d="M190.387,134.138l-27.415,42.051l-42.642-27.73l-15.554,26.596L38,180.884v46.391H0v-120h38v43.494l48.664-4.244
	l8.575-14.453L36.887,94.088l51.544-79.183l153.748,100.082L190.387,134.138z M173.874,183.244l19.924,12.971l27-41.474
	l-19.924-12.971L173.874,183.244z"/>

        </g>

    </svg>
)


// WEBPACK FOOTER //
// ./src/layout/icons/Camera.tsx